var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5C0 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5ZM5.24876 6.48155C5.78187 5.85515 6.72185 5.77952 7.34825 6.31263L12.633 10.8103L17.9177 6.31268C18.5441 5.77957 19.484 5.8552 20.0172 6.48161C20.5503 7.10801 20.4746 8.04799 19.8482 8.5811L14.931 12.766L19.8483 16.9509C20.4747 17.484 20.5503 18.424 20.0172 19.0504C19.4841 19.6768 18.5441 19.7524 17.9177 19.2193L12.633 14.7217L7.34823 19.2194C6.72182 19.7525 5.78185 19.6769 5.24874 19.0505C4.71563 18.4241 4.79126 17.4841 5.41766 16.951L10.335 12.766L5.41769 8.58104C4.79128 8.04793 4.71565 7.10796 5.24876 6.48155Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseblack);
export default __webpack_public_path__ + "static/media/close black.8e2f9c2c762a3d241bc76c19f75df5de.svg";
export { ForwardRef as ReactComponent };